export const FULL_NAME_MAX_LENGTH = 77;
export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;
export const STEP_6 = 6;

export const MAX_COMPANY_NAME_LENGTH = 50;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_YEARS_IN_BUSINESS_LENGTH = 3;
export const MAX_INDUSTRIES_LENGTH = 12;

export const MAX_REPRESENTED_NAME_LENGTH = 50;
export const YES_NO_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    displayText: "Yes",
    value: "Yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    displayText: "No",
    value: "No",
    subGroup: null
  }
];

export const COMPANY_STAKEHOLDER_ID = "companyStakeholder_";
